import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap/all';

import flowerone from './about1.jpeg';
import './Flowers1.css';

const Flowers1 = () => {
	let logoItem = useRef(null);

	useEffect(() => {
		gsap.to(logoItem, {
			delay: 1.2,
			x: 0,
			y: 0,
			scaleX: 1.2,
			scaleY: 1.2,
			opacity: 1,
		});
	}, []);

	return (
		<div className='acarphoto_items'>
			<ul className='acarphoto_item_ul'>
				<li
					className='acarphoto_item_li'
					ref={(el) => {
						logoItem = el;
					}}>
					<img className='acarphoto_item_img' src={flowerone} alt='flowertwo' />
				</li>
			</ul>
		</div>
	);
};

export default Flowers1;
